export default __webpack_public_path__ + "static/media/treeArrow.a635f737.svg";